<template>
  <div>
    <h2 class="h2-title">Inscreva-se e comece a aprender!</h2>
    <div class="container">
      <div class="input-margin">
        <t-input
          :placeholder="'Seu nome'"
          :name="'name'"
          :classIcon="'fas fa-user'"
          :type="'text'"
          v-model="createForm.name"
          :verifiyError="$v.createForm.name.$error"
          @blur="$v.createForm.$touch()"
        />
        <div class="errors-form-messages" v-if="$v.createForm.name.$error">
          <ul class="contactForm__messages" v-if="$v.createForm.name.$error">
            <li v-if="!$v.createForm.name.required">* O campo nome é obrigatório.</li>
          </ul>
        </div>
      </div>
      <div class="input-margin">
        <t-input
          :placeholder="'Seu sobrenome'"
          :name="'lastName'"
          :classIcon="'fas fa-user'"
          :type="'text'"
          v-model="createForm.lastName"
          :verifiyError="$v.createForm.lastName.$error"
          @blur="$v.createForm .$touch()"
        />
        <div class="errors-form-messages" v-if="$v.createForm.lastName.$error">
          <ul class="contactForm__messages" v-if="$v.createForm.lastName.$error">
            <li v-if="!$v.createForm.lastName.required">* O campo sobrenome é obrigatório.</li>
          </ul>
        </div>
      </div>
      <div class="input-margin">
        <t-input
          :placeholder="'Seu email'"
          :name="'email'"
          :classIcon="'fas fa-user'"
          v-model="createForm.email"
          :verifiyError="$v.createForm.email.$error"
          @blur="$v.createForm.$touch()"
        />
        <div class="errors-form-messages" v-if="$v.createForm.email.$error">
          <ul class="contactForm__messages">
            <li v-if="!$v.createForm.email.required">* O campo email é obrigatório.</li>
          </ul>
        </div>
      </div>
      <div class="input-margin">
        <t-input
          :placeholder="'Sua senha'"
          :name="'password'"
          :classIcon="'fas fa-user'"
          :type="'password'"
          v-model="createForm.password"
          :verifiyError="$v.createForm.password.$error"
          @blur="$v.createForm .$touch()"
        />
        <div class="errors-form-messages" v-if="$v.createForm.password.$error">
          <ul class="contactForm__messages" v-if="$v.createForm.password.$error">
            <li v-if="!$v.createForm.password.required">* O campo senha é obrigatório.</li>
          </ul>
        </div>
      </div>
      <div class="input-margin">
        <t-input
          :placeholder="'Confirme sua senha'"
          :name="'confirmPassword'"
          :type="'password'"
          :classIcon="'fas fa-user'"
          v-model="createForm.confirmPassword"
          :verifiyError="$v.createForm.confirmPassword.$error"
          @blur="$v.createForm.$touch()"
        />
        <div class="errors-form-messages" v-if="$v.createForm.confirmPassword.$error">
          <ul class="contactForm__messages">
            <li
              v-if="!$v.createForm.confirmPassword.required"
            >* O campo confirmar senha é obrigatório.</li>
            <li v-if="!$v.createForm.confirmPassword.sameAsPassword">* As senhas devem ser a mesma.</li>
          </ul>
        </div>
      </div>
      <div class="input-margin">
        <t-button class="button-width" @click="register()">Cadastrar</t-button>
      </div>
      <div>
        <p class="terms-ands-conditions">
          Ao inscrever-se, você concorda com nossos
          <a class="links">Termos de uso</a>e nossa
          <a class="links">Política de privacidade.</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TButton from '@/components/TButton.vue'
import TInput from '@/components/TInput.vue'
import notification from '@/support/mixins/notifications.mixin'
// import { mapActions } from 'vuex'
import { http } from '@/support/http/http'
import formErrors from '@/support/mixins/form-errors.mixin'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
export default {
  name: 'LoginStudent',
  components: {
    TButton,
    TInput
  },
  mixins: [notification, formErrors],
  data: () => ({
    createForm: {
      email: '',
      password: '',
      confirmPassword: '',
      name: '',
      lastName: ''
    }
  }),
  methods: {
    register () {
      const fields = [this.$v.createForm]
      this.verifyErrorsForm(fields)
        .then(() => {
          this.loading = true

          const email = this.createForm.email
          const password = this.createForm.password
          const name = this.createForm.name
          // eslint-disable-next-line camelcase
          const last_name = this.createForm.lastName
          http
            .post('register', { email, password, name, last_name })
            .then(() => {
              this.loading = false
              this.resetData()
              this.$v.$reset()
              this.successMsg(
                'Usuário',
                'Usuário cadastrado com sucesso, em poucos instantes, enviaremos um email para validar sua conta!',
                'topCenter'
              )
            })
            .catch(err => {
              this.resetData()
              this.$v.$reset()
              this.createForm = {}
              this.loading = false
              this.errorMsg(
                'Usuário',
                `${err.response.data.message}`,
                'topCenter'
              )
            })
        })
        .catch(() => {
          this.errorMsg(
            'Usuário',
            'Não foi possivel realizar o cadastro, verifique os erros no formulario',
            'topCenter'
          )
        })
    },
    resetData () {
      this.createForm.email = ''
      this.createForm.name = ''
      this.createForm.lastName = ''
      this.createForm.password = ''
      this.createForm.confirmPassword = ''
    }
  },
  validations: {
    createForm: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      name: {
        required
      },
      lastName: {
        required
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  }
}
</script>
<style scoped>
.terms-ands-conditions {
  margin: 0 0 16px;
  font-size: 0.8rem;
  text-align: center;
}
</style>
